
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import { IBreadCrumbRoute } from "@/types";
import TransProgramSeniorsContent from "@/components/transPrograms/TransProgramSeniorsContent.vue";
import LearnMore from "@/components/common/LearnMore.vue";

export default Vue.extend({
  name: "trans-program-seniors",
  components: { HeroBanner, BreadCrumb, LearnMore, TransProgramSeniorsContent },
  mixins: [UIFeatureMixin],
  data() {
    return {
      description:
        "Pennsylvania offers many transportation services to meet your needs.",
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "transProgramOverview" },
          text: "Transportation Programs",
        },
        {
          to: { name: "transProgramSeniors" },
          text: "Programs for Seniors",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "PGM_SSR,IMG_SNR,TPS_HERO_C,TPS_CON_1,TPS_CON_2,TPS_LEARN"
    );
  },
});
